import { constraints, datatypes, inputTypes, objType } from "data/globalData";
import SelectInputField from "components/PimDashboard/CommonComponents/InputComponents/SelectInputField";
import TextInputField from "components/PimDashboard/CommonComponents/InputComponents/TextInputField";
import { grey } from "@mui/material/colors";
import { attrGrpTableStrColumnsObj, constraintsOptions } from "components/PimDashboard/data";
import { getColDefaultValue } from "components/PimDashboard/data";
import { StudioDashboardState } from "context/StudioDashboardContext";

const RenderInputField = ({
	column,
	setData,
	data,
	width = "30%",
	longWidth = "60%",
	selectOptObjName,
	dependencyColData,
	multiple,
	attrGrp,
	error,
	errorObj,
	setError,
	disabled = false,
}) => {
	// console.log(column, "dependencyColDatadependencyColDatadependencyColData");
	const { allAttributes } = StudioDashboardState();
	const options = column[selectOptObjName] ? column[selectOptObjName] : { type: objType, list: {} };
	const hasError = typeof error === "object" ? Boolean(error?.[column?.key]) : Boolean(error);
	const currentErrorState =
		errorObj && typeof errorObj === "object" ? { ...errorObj } : error && typeof error === "object" ? { ...error } : {};

	const isDisabled = disabled || column?.input_type === inputTypes.AUTO_GENERATE.key;

	const sx = {
		display: "flex",
		alignItems: "center",
	};
	const inputSx = {
		width: "60%",
		flex: 1, // p: 1,
		background: isDisabled ? grey[300] : grey[100],
		fontWeight: 400,
		overflow: "hidden",
		boxSizing: "border-box",
		borderRadius: "0px 6px 6px 0px",
		"& .MuiOutlinedInput-root": {
			borderRadius: "0px 6px 6px 0px",

			"& fieldset": {
				borderLeft: "none",
			},

			"&:hover fieldset": {
				borderLeft: "none",
			},

			"&.Mui-focused fieldset": {
				borderLeft: "none",
			},
		},
	};
	const labelSx = {
		maxWidth: "38%",
		minWidth: "25%",
		borderRadius: "6px 0px 0px 6px",
		p: 1,
		background: "#000",
		color: grey[50],
	};

	const handleChange = (e) => {
		let obj = { ...data };
		let errorState = { ...currentErrorState };
		console.log(obj, "xzfcsdx");
		if (column?.data_type === datatypes.STRING.key && column?.input_type === inputTypes.ENTER.key)
			e.target.value = e.target.value?.toUpperCase();
		if (obj[attrGrp?.linked_table])
			obj = { ...obj, [column?.linked_table]: { ...obj[column?.linked_table], [column.key]: e.target.value } };
		else {
			obj[attrGrp?.linked_table] = {};
			if (obj[attrGrp?.group_id])
				obj = { ...obj, [column?.linked_table]: { ...obj[column?.linked_table], [column.key]: e.target.value } };
		}
		let dependentCols = allAttributes?.filter((row) => row?.dependency?.[column.key] === true);

		if (dependentCols?.length) {
			dependentCols.forEach((col) => {
				if (obj[col?.linked_table][col.key] !== getColDefaultValue(col)) {
					obj[col?.linked_table][col.key] = getColDefaultValue(col);
					errorState[col.key] = true;
				}
			});
		}
		if (column.key === "sub_brand") console.log(column, dependentCols, error, allAttributes, "jdksndlask.........");

		// for autogenerate functions
		if (typeof dependencyColData === "object") {
			Object.keys(dependencyColData)?.forEach((element) => {
				if (column.key === element)
					obj[dependencyColData[element].col.key] = dependencyColData[element].val(
						element,
						e.target.value,
						dependencyColData[element].col.key,
						options,
					);
			});
		}
		delete errorState[column.key];
		setError(errorState);

		setData(obj);
		// console.log(e, e.target.value, dependencyColData, obj, "dependencyColDatadependencyColDatadependencyColData");
	};

	if (column)
		if (column.input_type === inputTypes.ENTER.key || column.input_type === inputTypes.AUTO_GENERATE.key) {
			return (
				<TextInputField
					sx={sx}
					inputSx={inputSx}
					labelSx={labelSx}
					InputProps={{ sx: { borderRadius: "0px 1px 1px 0px" } }}
					data={data[column?.linked_table] ? data[column?.linked_table] : {}}
					setData={setData}
					onChange={handleChange}
					column={column}
					width={
						column?.data_type === datatypes.LONGTEXT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key
							? longWidth
							: width
					}
					required={column?.constraints[constraintsOptions.NOTNULL.key] ? true : false}
					type={column?.data_type}
					error={hasError}
					disabled={isDisabled}
				/>
			);
		} else {
			return (
				<SelectInputField
					sx={sx}
					inputSx={inputSx}
					labelSx={labelSx}
					data={data[column?.linked_table] ? data[column?.linked_table] : {}}
					setData={setData}
					column={column}
					width={
						column?.data_type === datatypes.LONGTEXT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key
							? longWidth
							: width
					}
					onChange={handleChange}
					options={options}
					required={column?.constraints[constraintsOptions.NOTNULL.key] ? true : false}
					isMultiple={column.input_type === inputTypes.MULTIPLE_SELECT.key || multiple}
					error={hasError}
					InputProps={{ sx: { borderRadius: "0px 5px 5px 0px" } }}
					disabled={isDisabled}
				/>
			);
		}
};

export default RenderInputField;
